import { create } from "zustand";

const USER_KEY = "trata_web_user";
const PROFILE_KEY = "trata_web_profile";
const EXP_KEY = "trata_web_session_exp";
const SESSION_MS = 7 * 24 * 60 * 60 * 1000; // 7 days ("Keep me logged in")

function loadInitial() {
  try {
    // Persistent (7-day) session takes priority; fall back to a session-only login
    // (sessionStorage) that is cleared automatically when the browser is closed.
    for (const store of [localStorage, sessionStorage]) {
      const raw = store.getItem(USER_KEY);
      const exp = parseInt(store.getItem(EXP_KEY) || "0", 10);
      if (raw && (!exp || exp > Date.now())) {
        const user = JSON.parse(raw);
        const profRaw = store.getItem(PROFILE_KEY);
        return { user, customerProfile: profRaw ? JSON.parse(profRaw) : null };
      }
    }
  } catch (e) {
    // ignore
  }
  return { user: null, customerProfile: null };
}

const initial = loadInitial();

export const useAuthStore = create((set, get) => ({
  user: initial.user,
  customerProfile: initial.customerProfile,
  isAuthenticated: !!initial.user,

  // remember=true → persist 7 days (localStorage). remember=false → session-only
  // (sessionStorage), so the user is logged out when the browser/tab is closed.
  setSession: (user, customerProfile = null, remember = true) => {
    try {
      const store = remember ? localStorage : sessionStorage;
      const other = remember ? sessionStorage : localStorage;
      [other.removeItem(USER_KEY), other.removeItem(PROFILE_KEY), other.removeItem(EXP_KEY)];
      store.setItem(USER_KEY, JSON.stringify(user));
      store.setItem(EXP_KEY, String(Date.now() + SESSION_MS));
      if (customerProfile) store.setItem(PROFILE_KEY, JSON.stringify(customerProfile));
    } catch (e) {
      // storage unavailable — keep in-memory session
    }
    set({ user, customerProfile: customerProfile || get().customerProfile, isAuthenticated: true });
  },

  setProfile: (customerProfile) => {
    try {
      if (customerProfile) {
        // write to whichever store currently holds the session
        const store = localStorage.getItem(USER_KEY) ? localStorage : sessionStorage;
        store.setItem(PROFILE_KEY, JSON.stringify(customerProfile));
      }
    } catch (e) {
      // ignore
    }
    set({ customerProfile });
  },

  logout: () => {
    try {
      for (const store of [localStorage, sessionStorage]) {
        store.removeItem(USER_KEY);
        store.removeItem(PROFILE_KEY);
        store.removeItem(EXP_KEY);
      }
    } catch (e) {
      // ignore
    }
    set({ user: null, customerProfile: null, isAuthenticated: false });
  },

  displayName: () => {
    const s = get();
    return (
      s.customerProfile?.basicInfo?.fullName ||
      s.customerProfile?.fullName ||
      s.user?.name ||
      "there"
    );
  },
}));
